import {NavigationPageType} from '~shared/models';

import {NavigationEntityState} from '~ui/store/slices/navigation-tree';

import {removeChildAtIndex} from './children';

export function deletePageNavigation(
    entities: Record<string, NavigationEntityState>,
    slug: string,
) {
    const entity = entities[slug];

    if (!entity) return;

    // item has children, we can't remove it
    // but we must make it a gap
    if (entity.children.length > 0) {
        entity.type = NavigationPageType.Gap;
        return;
    }

    // item has no children, we could safely remove it
    delete entities[slug];

    let currentEntity = entity;

    // remove all page ancestors that are also gaps
    // and don't have any other children
    while (currentEntity) {
        const parentEntity = currentEntity.parent ? entities[currentEntity.parent] : undefined;

        if (!parentEntity) return;

        if (parentEntity.type === NavigationPageType.Gap && parentEntity.children.length < 2) {
            deleteEntity(entities, parentEntity.slug);
        } else {
            const index = parentEntity.children.indexOf(slug);
            if (index !== -1) {
                removeChildAtIndex(parentEntity, index);
            }

            return;
        }

        currentEntity = parentEntity;
    }
}

function deleteEntity(entities: Record<string, NavigationEntityState>, slug: string) {
    const entity = entities[slug];

    if (!entity) return;

    delete entities[slug];

    const parent = entity.parent ? entities[entity.parent] : undefined;

    if (!parent) return;

    const index = parent.children.indexOf(slug);

    if (index === -1) return;

    removeChildAtIndex(parent, index);
}
